import { FC, useContext } from 'react';

import { useQuery } from '@apollo/client';
import { InfoBlock, Preloader } from '@smartshell/ui-kit';

import { WorkerBlock, Deposit, Proceeds, MoneyByType } from 'components';
import { FeatureHOC } from 'features';
import { useWindowResize } from 'hooks';
import { LocalizationContext } from 'localization';
import {
  GET_WORK_SHIFT_BY_ID,
  GET_WORKSHIFT_MONEY,
  IGetWorkShiftMoneyRequest,
  IGetWorkShiftMoneyResponse,
  IWorkShiftByIdRequest,
  IWorkShiftByIdResponse,
} from 'schemas';

import { PaymentsChart } from './PaymentsChart';
import s from './WorkShiftReport.module.scss';

export interface IWorkShiftReportProps {
  workShiftId: number;
}
export const WorkShiftReport: FC<IWorkShiftReportProps> = ({ workShiftId }) => {
  const { t } = useContext(LocalizationContext);
  const { data, loading, error } = useQuery<
    IWorkShiftByIdResponse,
    IWorkShiftByIdRequest
  >(GET_WORK_SHIFT_BY_ID, {
    variables: { id: workShiftId },
  });
  const size = useWindowResize();
  useQuery<IGetWorkShiftMoneyResponse, IGetWorkShiftMoneyRequest>(
    GET_WORKSHIFT_MONEY,
    {
      fetchPolicy: 'cache-first',
      variables: { id: workShiftId },
    }
  );

  if (loading || !data || error) {
    return (
      <Preloader
        loading
        hasData={Boolean(data)}
        noDataPlaceholder={t('workShift.details.data.error')}
      />
    );
  }

  return (
    <div className={s.container}>
      <div className={s['fast-info']}>
        <div className={s.block}>
          <WorkerBlock isLoading={loading} workShiftId={workShiftId} />
          <Proceeds workShiftId={workShiftId} small />
        </div>
        <div className={s.block}>
          <MoneyByType workShiftId={workShiftId} small />
          <Deposit workShiftId={workShiftId} small />
        </div>
      </div>
      {size.width > 960 ? (
        <FeatureHOC
          alias="work_shift_reports"
          strategy="replace"
          name={t('workShift.detail.chart')}
          fullHeight
          grayBG
        >
          <PaymentsChart workShift={data.workShift} />
        </FeatureHOC>
      ) : (
        <InfoBlock
          className={s.mobile_info}
          title={t('mobile.placeholder')}
          iconName="ComputerIcon"
          color="blue"
        />
      )}
    </div>
  );
};
